import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CacheService } from '../services/cache.service';
import { environment } from '../../environments/environment';

@Injectable()
/**
 * Interceptor adds the additional information to request header
 * to be sent to backend.
 */
export class AdditionalInfoInterceptor implements HttpInterceptor {
  constructor(private cacheService: CacheService) {}
  private C_CUSTOMER = environment.customerStorageKey;
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const customer = this.cacheService.getStorageData(this.C_CUSTOMER);
    if (customer) {
      // const newHeaders = new HttpHeaders();
      const newHeaders = request.headers
        .set('Aline-customer', customer?.id)
        .set('Aline-ui-url', window.location.href);
      // TODO: IP-osoite
      // console.log(newHeaders);
      request = request.clone({
        headers: newHeaders
      });
    }
    return next.handle(request);
  }
}
